import { getFee } from './states';

export const services = {
  getFee,
};
